import type { ManagerialDashboardSection } from '@/types/api'
import type { DashboardBlockState } from '../lib/dashboard-loader'
import { DASHBOARD_SECTION_LABELS } from '../lib/dashboard-sections'
import styles from '../DashGerencialPage.module.css'

export function DashboardSectionStatus({
  section,
  state,
  onRetry,
}: {
  section: ManagerialDashboardSection
  state: DashboardBlockState
  onRetry: () => void
}) {
  const date = state.data ? Date.parse(state.data.generated_at) : Number.NaN
  return (
    <div
      className={styles.blockStatus}
      aria-label={`Situação: ${DASHBOARD_SECTION_LABELS[section]}`}
    >
      {state.error ? (
        <p className={styles.error} role="alert">
          {DASHBOARD_SECTION_LABELS[section]}: {state.error}
          {state.data ? ' Exibindo a última consulta concluída deste bloco.' : ''}
          <button type="button" onClick={onRetry} disabled={state.isLoading}>
            Tentar este bloco novamente
          </button>
        </p>
      ) : state.isLoading ? (
        <span role="status">
          {DASHBOARD_SECTION_LABELS[section]}:{' '}
          {state.data ? 'atualizando...' : 'carregando...'}
        </span>
      ) : null}
      {Number.isFinite(date) ? (
        <small>
          Atualizado em{' '}
          {new Intl.DateTimeFormat('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short',
            timeZone: 'America/Sao_Paulo',
          }).format(new Date(date))}{' '}
          · Brasília
        </small>
      ) : null}
    </div>
  )
}
